module.exports = __webpack_public_path__ + "static/img/1.8a294c93.jpg";